import React from 'react';
import PropTypes from 'prop-types';
import SelectModalPanel from './SelectModalPanel';

/**
 * SelectType
 */
class SelectType extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      type: this.props.data.type,
      masterList: []
    };

    this.handleModalShowChange = this.handleModalShowChange.bind(this);
    this.isModalOpen = false;
    this.itemList = [];
  }


  // このボックスの表示データを取得
  componentDidMount() {
    this.props.comactions.onMountedType();
  }

  /**
   * タイプ選択画面を表示する
   */
  handleModalShowChange(checkedList) {
    if (this.isModalOpen) {
      this.isModalOpen = false;
      if (checkedList != null && checkedList != undefined) {
        this.props.data.typeIds = checkedList;
      }
      this.setState({ masterList: [] });
      $('#modal_type_select_panel').hide();
    } else {
      this.isModalOpen = true;
      this.setState({ masterList: this.itemList });
      $('#modal_type_select_panel').show();
    }
  }


  render() {
    // 表示データを取得
    let itemList = [];
    // 表示データを生成
    if (this.props.pskubun == 1) {
      itemList = this.props.data.itemList.typeList['slotList'];
    } else {
      itemList = this.props.data.itemList.typeList['pachinkoList'];
    }

    this.itemList = itemList;
    // // 画面表"すべて"を追加する。
    // let displayItemList = [];
    // if (itemList.length > 1) {

    //   const allItem = [{ id: 0, display_name: 'すべて' }];
    //   displayItemList = allItem;
    //   let j = 1;
    //   for (let i = 0; i < itemList.length; i++) {
    //     displayItemList[j++] = itemList[i];
    //   }
    // } else {
    //   displayItemList = itemList;
    // }

    // const type = this.state.type;

    // const nodes = displayItemList.map((item) => {
    //   return (
    //     <option value={item.id} key={item.id}>
    //       {item.display_name}
    //     </option>
    //   );
    // });

    let SelectModalPanelNodes = null;
    if (itemList.length != 0) {
      SelectModalPanelNodes = (
        <SelectModalPanel
          masterList={this.state.masterList}
          handleModalShowChange={this.handleModalShowChange}
          modalTitle={'タイプ'}
          allCheckText={'すべて'}
          checkedList={this.props.data.typeIds}
          idKey={'id'}
          valueKey={'display_name'}
        />
      );
    }

    return (
      // <div>
      //   <div className="ctrl_form_title controlForm__titleSemiRequire--state_enable controlForm__text--state_enable"><p>タイプ</p></div>
      //   <label className="select">
      //     <select name="pw_extraction_02" id="selectType" value={type} className="form-control" onChange={e => this.handleTypeChange(e.target.value)}>
      //       {nodes}
      //     </select>
      //   </label>
      // </div >
      <div>
        <div className="ctrl_form_title controlForm__title--state_enable controlForm__text--state_enable">
          <p>タイプ</p>
        </div>
        <label className="select_panel_content_parent" onClick={() => this.handleModalShowChange()}>
          <div id="selectType" className="select_type_content">
            <p>ccc</p>
          </div>
        </label>

        <div id="modal_type_select_panel" className="modal_select_panel">
          {SelectModalPanelNodes}
        </div>

      </div>
    );
  }
}

SelectType.propTypes = {
  actions: PropTypes.any.isRequired,
  comactions: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired
};

export default SelectType;
